import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LinkUserDto } from 'src/app/models/ps-user.model';
import { UserService } from 'src/app/services/uppy/user.service';
import { TrainingProgramApplicationUtils } from 'src/app/utils/training-program-application.util';

@Component({
    selector: 'app-register-worker-redirect',
    templateUrl: './register-worker-redirect.component.html',
    styleUrls: ['./register-worker-redirect.component.scss'],
    standalone: false
})
export class RegisterWorkerRedirectComponent implements OnInit {
  currentLang: string;
  constructor(
    public translateService: TranslateService,
    @Inject('UserService') public userService: UserService,
    public router: Router,
    public route: ActivatedRoute) { }

  ngOnInit(): void {
    this.currentLang = this.translateService.currentLang;
    this.route.queryParams.subscribe(param => {
      if (param['id'] != null && param['id'] != undefined) {
        let linkUserDTO = { EncryptedPersonId: param['id'] } as LinkUserDto 
        this.userService.CreateWorkerAccount(linkUserDTO).subscribe(x => {
          if (x) { 
            //Now redirect user to worker profile page if this is the first time the user logging into CMS,
            // otherwise redirect user to certificate page
            let page = x.ID == TrainingProgramApplicationUtils.EmptyGuid ? '/worker/certifications' : '/worker/profile-setup'; 
            this.router.navigate([(this.currentLang == 'fr' ? '/fr' : '') + page]);
          }
        },
        (error) => { //probably unauthorized - send user to error page
          this.router.navigate([(this.currentLang == 'fr' ? '/fr' : '') + '/worker/error']);
        });
      }
    })
  }
}
